export const NOTICES_PAGE_TABS = {
  ACTIVE: 'active',
  UPCOMING: 'upcoming',
  PAST: 'past',
} as const;

export type NoticesPageTab = (typeof NOTICES_PAGE_TABS)[keyof typeof NOTICES_PAGE_TABS];
